<template>
    <div>
        <i
            class="fa fa-paperclip fa-lg icon-button"
            title="Anexos do Processo"
            @click.stop="abrirModal()"
            v-if="!processoCancelado"
        ></i>
        <b-modal
            id="modalAnexosProcessoAtaDirex"
            size="lg"
            v-model="mostrarModal"
            no-close-on-backdrop
        >
            <div slot="modal-title">
                Anexos do Processo -
                <b-badge variant="warning">{{
                    processoAtaDirex.nuProcesso
                }}</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <div>
                <b-row>
                    <b-col sm="12" md="12">
                        <b-card no-body>
                            <b-card-header>
                                <span class="h5"> Anexos </span>
                            </b-card-header>
                            <b-card-body>
                                <app-tabela
                                    idTabela="anexosProcessoAta"
                                    :itens="anexosprocessoatadirexLista"
                                    :campos="campos"
                                    :itensPorPagina="itensPorPagina"
                                    :bordered="false"
                                    :small="false"
                                >
                                    <template slot="botoes">
                                        <b-button-group class="float-right">
                                            <Cad-Anexos
                                                @ListarAnexos="listar()"
                                                :processoAta="processoAtaDirex"
                                                v-if="
                                                    $temAcessoView(
                                                        'ATADIREX-15'
                                                    )
                                                "
                                            >
                                            </Cad-Anexos>
                                        </b-button-group>
                                    </template>
                                    <template slot="acoes" slot-scope="data">
                                        <span
                                            class="text-danger float-left mr-1"
                                        >
                                            <i
                                                class="
                                                    fa fa-trash fa-lg
                                                    icon-button
                                                "
                                                title="Excluir Anexo"
                                                @click.stop="
                                                    confirmarExcluirAnexo(data)
                                                "
                                                v-if="
                                                    $temAcessoView(
                                                        'ATADIREX-16'
                                                    )
                                                "
                                            ></i>
                                        </span>
                                        <span
                                            class="text-success float-left mr-1"
                                        >
                                            <i
                                                class="
                                                    fa fa-download fa-lg
                                                    icon-button
                                                "
                                                title="Download"
                                                @click.stop="
                                                    confirmarDownload(data)
                                                "
                                                v-if="
                                                    $temAcessoView(
                                                        'ATADIREX-17'
                                                    )
                                                "
                                            ></i>
                                        </span>
                                    </template>
                                </app-tabela>
                            </b-card-body>
                        </b-card>
                    </b-col>
                </b-row>
            </div>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()"
                    >Fechar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>


<script>
import AtaDirexServicos from './AtaDirexServicos'
import CadAnexos from './cadastro/CadAnexo.vue'

export default {
    components: {
        CadAnexos
    },

    props: {
        processoAtaDirex: Object,
        idProcesso: 0,
        processoCancelado: Boolean
    },

    data() {
        return {
            anexosprocessoatadirexLista: [],
            erros: [],
            mostrarModal: false,
            itensPorPagina: 5,
            campos: [
                {
                    key: 'vcDescricaoAnexo',
                    label: 'Descrição',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'vcNomeArquivo',
                    label: 'Arquivo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ]
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
            this.listar()
        },
        fecharModal() {
            this.mostrarModal = false
        },

        listar() {
            this.$store.dispatch('addRequest')
            AtaDirexServicos.ListarAnexos(this.idProcesso).then((response) => {
                if (response) {
                    if (response.success) {
                        this.anexosprocessoatadirexLista = response.data
                    } else {
                        this.$toast.error(response.errors, 'ERROR', this.error)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarExcluirAnexo(data) {
            this.$swal({
                title:
                    'Excluir Anexo do Processo: ' +
                    this.processoAtaDirex.nuProcesso,
                html: `Confirma a Exclusão do Anexo <b>${data.vcNomeArquivo}</b>?
                <br/><br/>`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.ExcluirAnexo(data.idAnexo)
                }
            })
        },

        ExcluirAnexo(id) {
            this.$store.dispatch('addRequest')
            AtaDirexServicos.ExcluirAnexo(id).then((response) => {
                if (response) {
                    this.listar()
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarDownload(data) {
            this.$swal({
                title:
                    'Download do Arquivo Anexado ao Processo: ' +
                    this.processoAtaDirex.nuProcesso,
                html: `Confirma o Download do Arquivo: <b>${data.vcNomeArquivo}</b>?
                <br/><br/>`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.download(data)
                }
            })
        },

        download(doc) {
            this.$store.dispatch('addRequest')
            AtaDirexServicos.downloadAnexo(doc.idAnexo).then((response) => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro no Download!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.$download(response, doc.vcNomeArquivo)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    }
}
</script>
